import PATH from "constants/path";
import React, { useState, useEffect } from "react";
import {
  LIST_MENU_MOBILE_AUTH_1,
  LIST_MENU_MOBILE_AUTH_2,
  LIST_MENU_MOBILE_NO_AUTH,
} from "./constants";
import {
  ButtonLoginMenu,
  ButtonRegisterMenu,
  ButtonMenuClose,
} from "assets/svg";
import { itsumoni_logo_white } from "assets/img";
import { isAuthenticated } from "utils/common";

function Menu({ openMenu, setOpenMenu, handleLogout, handleLogin, user, isInLine }) {
  const hasLogin = isAuthenticated();

  const [translateX, setTranslateX] = useState(0);
  const [swipe, setSwipe] = useState({});

  const onTouchStart = (e) => {
    const width = window.innerWidth;
    const touch = e.touches[0];
    setTranslateX(0);
    setSwipe({ x: touch.clientX, width });
  };

  const onTouchMove = (e) => {
    if (swipe.x) {
      const touch = e.changedTouches;
      if (touch && touch.length) {
        if (touch[0].clientX > swipe.x && translateX < 40) {
          const absX = touch[0].clientX - swipe.x;
          const translate = (absX / swipe.width) * 100;
          if (translate > 40) {
            // đóng menu
            setOpenMenu("");
            return;
          }
          setSwipe({ swiping: true, ...swipe });
          setTranslateX(translate);
        }
      }
    }
  };

  const onTouchEnd = (e) => {
    setSwipe({});
  };

  const onScrollMenu = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (openMenu === "active") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [openMenu]);

  return (
    <div
      className={`sidebar-custom ${
        hasLogin ? "auth" : ""
      } ${openMenu} cursor-pointer`}
      id="sidebar"
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onTouchMove={onTouchMove}
      style={
        swipe?.swiping === true && openMenu === "active"
          ? { transform: "translateX(" + (100 - translateX) + "%)" }
          : {}
      }
    >
      <div className="close" onClick={() => setOpenMenu("")}>
        <ButtonMenuClose />
      </div>
      {hasLogin ? (
        <div className="sidebar-menu" onTouchStart={onScrollMenu}>
          <div className="px-4 py-2 text-white sidebar-menu-header">
            <div className="title">
              {isInLine ? <span>****</span> : user && user?.name}  さん、ようこそ
            </div>
            <div className="subtitle">[会員番号: {isInLine ? <span>****</span> : user?.id} ]</div>
          </div>
          <div className="h-menu">
            <div className="bg-grey pt-2">
              <div className="bg-white px-4">
                <ul>
                  {LIST_MENU_MOBILE_AUTH_1.map((item, index) => (
                    <li key={index} className="menu-item">
                      <a className="menu-link" href={item.path}>
                        {item.name}
                      </a>
                    </li>
                  ))}
                  <li className="menu-item">
                    <div className="menu-link" onClick={() => handleLogout()}>
                      ログアウト
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="bg-grey py-2">
              <div className="bg-white px-4">
                <ul>
                  {LIST_MENU_MOBILE_AUTH_2.map((item, index) => (
                    <li key={index} className="menu-item">
                      <a className="menu-link" href={item.path}>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="px-4 mb-5 pb-5">
              <ul>
                <li className="menu-item-2">
                  <a className="menu-link" href={PATH.COMMON + PATH.AGREEMENT}>
                    会員規約
                  </a>
                </li>
                <li className="menu-item-2">
                  <a
                    className="menu-link"
                    href={PATH.COMMON + PATH.INFORMATION}
                    target="_blank"
                  >
                    プライバシーポリシー
                  </a>
                </li>
                <li className="menu-item-2">
                  <a
                    className="menu-link"
                    href={PATH.COMPANY}
                    target="_blank"
                  >
                    運営会社について
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <div className="sidebar-menu" onTouchStart={onScrollMenu}>
          <div className="px-4 py-3 text-white sidebar-menu-header">
            <img src={itsumoni_logo_white} alt="itsumoni_logo_white" />
          </div>
          <div className="h-menu px-4">
            <div className="row gx-1 my-3">
              <div className="col-6">
                <div onClick={() => handleLogin()} className="cursor-pointer">
                  <ButtonLoginMenu />
                </div>
              </div>
              <div className="col-6">
                <div
                  onClick={() => (window.location = PATH.COMMON + PATH.SIGNUP)}
                  className="cursor-pointer"
                >
                  <ButtonRegisterMenu />
                </div>
              </div>
            </div>

            <div className="bg-white my-3">
              <ul className="px-0">
                {LIST_MENU_MOBILE_NO_AUTH.map((item, index) => (
                  <li key={index} className="menu-item">
                    <a className="menu-link" href={item.path}>
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-white mb-5 pb-5">
              <ul className="px-0">
                <li className="menu-item-2">
                  <a className="menu-link" href={PATH.COMMON + PATH.AGREEMENT}>
                    会員規約
                  </a>
                </li>
                <li className="menu-item-2">
                  <a
                    className="menu-link"
                    href={PATH.COMMON + PATH.INFORMATION}
                    target="_blank"
                  >
                    プライバシーポリシー
                  </a>
                </li>
                <li className="menu-item-2">
                  <a
                    className="menu-link"
                    href={PATH.COMPANY}
                    target="_blank"
                  >
                    運営会社について
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Menu;
